import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { z } from "zod";
import { ConnectWithEntraIdButton } from "../connect-entra-id-button";
import { IntegrationForm } from "../integration-form";
import { OrBorder } from "../or-border";

const controlCode = ControlCodes.DEFENDER;
const controlName = getControlName(controlCode);

export const DefenderIntegrationForm = ({
  instance,
}: {
  instance?: Control;
}) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`Connect ${controlName} to begin assessment of control deployment, health and configuration. When connecting, an app registration will
        be created, requiring a set of permissions for successful setup`}
    extraOptions={
      <>
        <ConnectWithEntraIdButton
          controls={[
            {
              controlCode,
              instanceId: instance?.instance_id ?? "",
              instanceName: instance?.name ?? "",
              baseUrl:
                instance?.api ?? "https://api.securitycenter.microsoft.com/",
            },
          ]}
        />

        <OrBorder />
      </>
    }
    fields={{
      baseUrl: {
        label: "Base URL",
        type: "url",
        defaultValue:
          instance?.api ?? "https://api.securitycenter.microsoft.com/",
        placeholder: "https://api.securitycenter.microsoft.com/",
        required: true,
        validator: z.string().url(),
      },
      tenantId: {
        label: "Tenant ID",
        defaultValue: instance?.username,
        placeholder: "Enter your Tenant ID",
        required: true,
        validator: z.string().min(1),
      },
      appId: {
        label: "App ID",
        placeholder: "Enter your App ID",
        required: true,
        validator: z.string().min(1),
      },
      appSecret: {
        label: "App Secret",
        type: "password",
        required: true,
        placeholder: `Enter your App Secret`,
        validator: z.string().min(1),
      },
    }}
    transformParams={({ baseUrl, tenantId, appId, appSecret }) => ({
      api: baseUrl,
      user: tenantId,
      secret: `${appId}/${appSecret}`,
    })}
  />
);
